import React, { useState } from "react";
import ImageUploader from "react-images-upload";
import PropTypes from "prop-types";
//import { Test } from './AvatarUpload.styles';

const AvatarUpload = (props) => {
  const [pictures, setPictures] = useState([]);
  const onDrop = (picture) => {
    console.log("picture:", picture);
    setPictures([...pictures, picture]);
    props.onChange(picture);
  };
  return (
    <ImageUploader
      {...props}
      withIcon={true}
      withPreview={true}
      singleImage={true}
      onChange={onDrop}
      buttonText={`Choose image`}
      imgExtension={[".jpg", ".gif", ".png", ".gif"]}
      maxFileSize={5242880}
    />
  );
};

AvatarUpload.propTypes = {
  // bla: PropTypes.string,
};

AvatarUpload.defaultProps = {
  // bla: 'test',
};

export default AvatarUpload;
